/* istanbul ignore file */

import 'core-js/features/array/find';
import 'core-js/features/array/includes';
import 'core-js/features/number/is-nan';

require('es6-promise').polyfill();
